import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import {
  // IconButton,
  AppBar,
  Tabs,
  Tab,
  Box,
  // Paper,
  Divider,
  Fade,
} from "@mui/material";
import { Typography, TextField } from "@mui/material";
// import SwipeableViews from 'react-swipeable-views';
import PropTypes from "prop-types";
import CreateCategoryForm from "./CreateCategoryForm";
import Autocomplete from "@mui/material/Autocomplete";
// import RemoveIcon from '@mui/icons-material/Remove';
// import AddIcon from '@mui/icons-material/Add';
import Chip from "@mui/material/Chip";
import DoneIcon from "@mui/icons-material/Done";

const PREFIX = "LinkSubCategories";

const classes = {
  rootContainer: `${PREFIX}-rootContainer`,
  marginBottom: `${PREFIX}-marginBottom`,
  marginTop: `${PREFIX}-marginTop`,
  chosenCategory: `${PREFIX}-chosenCategory`,
  searchAutocomplete: `${PREFIX}-searchAutocomplete`,
  tagsMainContainer: `${PREFIX}-tagsMainContainer`,
  tagContainer: `${PREFIX}-tagContainer`,
  divider: `${PREFIX}-divider`,
  autocompleteContainer: `${PREFIX}-autocompleteContainer`,
  chipElement: `${PREFIX}-chipElement`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.rootContainer}`]: {
    // minWidth: '500px',
    // minHeight: '500px',
    // maxWidth: '100%',
    // maxHeight: '100%',
  },

  [`& .${classes.marginBottom}`]: {
    marginBottom: "1rem",
  },

  [`& .${classes.marginTop}`]: {
    marginTop: "1rem",
  },

  [`& .${classes.chosenCategory}`]: {},

  [`& .${classes.searchAutocomplete}`]: {
    width: "100%",
    maxWidth: "350px",
    marginBottom: "1rem",
  },

  [`& .${classes.tagsMainContainer}`]: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
  },

  [`& .${classes.tagContainer}`]: {
    height: "60px",
    display: "flex",
    justifyContent: "space-between",
    padding: "1rem 1rem",
    marginBottom: "1rem",
  },

  [`& .${classes.divider}`]: {
    marginBottom: "1rem",
  },

  [`& .${classes.autocompleteContainer}`]: {
    display: "flex",
    justifyContent: "center",
  },

  [`& .${classes.chipElement}`]: {
    margin: theme.spacing(0.5),
  },
}));

const TabPanel = React.forwardRef((props, ref) => {
  const { children, value, index, ...other } = props;

  return (
    <Root ref={ref}>
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    </Root>
  );
});

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const LinkSubCategories = (props) => {
  const theme = useTheme();

  const { t } = useTranslation();
  const [panelValue, setPanelValue] = useState(0);
  const [newTags, setNewTags] = useState([]);
  const [filteredTags, setFilteredTags] = useState(null);

  useEffect(() => {
    if (props.triggerUpdate) {
      props.setUpdateCategoryTags(newTags);
      if (panelValue > 0) {
        // swipeable mount and unmount views, so when there have the trigger,
        // the create form isn't mounted and can't send the infos, so we get the infos from the parent
        props.setUpdateCategoryInfos(props.selectedCategory);
      }
    }
  }, [props.triggerUpdate]);

  useEffect(() => {
    if (props.selectedCategory.hashtags) {
      setNewTags(props.selectedCategory.hashtags);
    }
  }, []);

  const { selectedCategory, tags } = props;

  const handleChange = (event, newValue) => {
    setPanelValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setPanelValue(index);
  };

  const handleSearch = (data) => {
    if (!data) setFilteredTags(null);
    else setFilteredTags(tags.filter((item) => item === data));
  };

  // const TagItem = (props) => (
  //   <Paper elevation={6} className={classes.tagContainer} style={{ border: props.exists && `1px solid ${theme.palette.primary.main}` }}>
  //     <Typography variant="body2" className={classes.tagTitle} style={{ color: props.exists && theme.palette.primary.main }}>{props.tagName}</Typography>
  //     {props.exists ?
  //       <IconButton
  //         color="primary"
  //         aria-label="upload picture"
  //         component="span"
  //         className={classes.deleteIcon}
  //         onClick={e => {
  //           e.stopPropagation();
  //           let tmp = [...newTags];
  //           const index = tmp.findIndex(name => name === props.tagName)
  //           tmp.splice(index, 1);
  //           setNewTags(tmp);
  //         }}
  //         size="large">
  //         <RemoveIcon />
  //       </IconButton>
  //       :
  //       <IconButton
  //         color="primary"
  //         aria-label="upload picture"
  //         component="span"
  //         className={classes.deleteIcon}
  //         onClick={e => {
  //           e.stopPropagation();
  //           let tmp = [...newTags];
  //           tmp.push(props.tagName)
  //           setNewTags(tmp);
  //         }}
  //         size="large">
  //         <AddIcon />
  //       </IconButton>
  //     }
  //   </Paper>
  // )

  return (
    <Root>
      <div className={classes.rootContainer}>
        <div>
          <div className={classes.chosenCategory}>
            {selectedCategory && tags && (
              <React.Fragment>
                <AppBar position="static" color="default">
                  <Tabs
                    value={panelValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                  >
                    <Tab
                      label={t("categories.link.informations")}
                      {...a11yProps(0)}
                    />
                    <Tab label={t("categories.link.tags")} {...a11yProps(1)} />
                  </Tabs>
                </AppBar>
                {/* <SwipeableViews
                  axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                  index={panelValue}
                  onChangeIndex={handleChangeIndex}
                > */}
                <TabPanel value={panelValue} index={0} dir={theme.direction}>
                  <CreateCategoryForm
                    updateMod
                    selectedCategory={selectedCategory}
                    setUpdateCategoryInfos={props.setUpdateCategoryInfos}
                    triggerUpdate={props.triggerUpdate}
                  />
                </TabPanel>
                <TabPanel value={panelValue} index={1} dir={theme.direction}>
                  <div className={classes.autocompleteContainer}>
                    <Autocomplete
                      id="search-tags-autocomplete"
                      className={classes.searchAutocomplete}
                      options={tags || []}
                      getOptionLabel={(option) => {
                        return option?.length > 30
                          ? option.substr(0, 30) + "..."
                          : option;
                      }}
                      onChange={(e, data) => handleSearch(data)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("categories.searchTagAutocomplete")}
                          variant="outlined"
                        />
                      )}
                    />
                  </div>
                  <Divider light className={classes.divider} />
                  <div className={classes.tagsMainContainer}>
                    {filteredTags && filteredTags.length > 0 ? (
                      filteredTags.map((tagName, index) => (
                        <Chip
                          key={`${tagName}-${index + 1}`}
                          label={tagName}
                          clickable
                          color={
                            newTags.includes(tagName) ? "primary" : "default"
                          }
                          onClick={() => {
                            if (newTags.includes(tagName)) {
                              let tmp = [...newTags];
                              const index = tmp.findIndex(
                                (name) => name === tagName
                              );
                              tmp.splice(index, 1);
                              setNewTags(tmp);
                            } else {
                              let tmp = [...newTags];
                              tmp.push(tagName);
                              setNewTags(tmp);
                            }
                          }}
                          onDelete={
                            newTags.includes(tagName) ? () => null : undefined
                          }
                          deleteIcon={
                            newTags.includes(tagName) ? <DoneIcon /> : null
                          }
                          className={classes.chipElement}
                        />
                      ))
                    ) : tags && tags.length > 0 ? (
                      tags.map((tagName, index) => (
                        <Chip
                          key={`${tagName}-${index + 1}`}
                          label={tagName}
                          clickable
                          color={
                            newTags.includes(tagName) ? "primary" : "default"
                          }
                          onClick={() => {
                            if (newTags.includes(tagName)) {
                              let tmp = [...newTags];
                              const index = tmp.findIndex(
                                (name) => name === tagName
                              );
                              tmp.splice(index, 1);
                              setNewTags(tmp);
                            } else {
                              let tmp = [...newTags];
                              tmp.push(tagName);
                              setNewTags(tmp);
                            }
                          }}
                          onDelete={
                            newTags.includes(tagName) ? () => null : undefined
                          }
                          deleteIcon={
                            newTags.includes(tagName) ? <DoneIcon /> : null
                          }
                          className={classes.chipElement}
                        />
                      ))
                    ) : (
                      <div className={classes.noDisplayContainer}>
                        <Typography variant="body1">
                          {t("categories.noCategories")}
                        </Typography>
                      </div>
                    )}
                  </div>
                </TabPanel>
                {/* </SwipeableViews> */}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </Root>
  );
};

export default LinkSubCategories;
